import { render, staticRenderFns } from "./UserIntegralCategoryList.vue?vue&type=template&id=994079f4&scoped=true"
import script from "./UserIntegralCategoryList.vue?vue&type=script&lang=js"
export * from "./UserIntegralCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994079f4",
  null
  
)

export default component.exports